import BaseOrganizationController from "@rmp/core/api/base/baseOrganizationController";

export class AuthorizationController extends BaseOrganizationController {
	getPermissions = async (): Promise<string[]> => {
		const { data } = await this.api.permissions.getPermissions();
		
		return data.map((x) => x.systemName);
	};
}
